<div class="user-avatar" (click)="userOverlay.toggle($event)">
  <p-avatar
    *ngIf="hasAvatar"
    [image]="userAvatarUrl"
    shape="circle"
    [style]="{ 'background-color': 'transparent' }"></p-avatar>
  <p-avatar
    *ngIf="!hasAvatar"
    [label]="userAvatarLabel"
    shape="circle"></p-avatar>
</div>
<p-popover #userOverlay>
  <app-user-profile-view [user]="user"></app-user-profile-view>
</p-popover>
